<template>
  <div class="card-single">
    <div class="card-information">
      <div class="card-info-cell">
        <div>
          <p>Kreditna kartica</p>
          <h3>{{$props.cardName}}</h3>
        </div>
      </div>
      <div class="card-info-cell">
        <div>
          <p>Broj kartice</p>
          <h3>{{$props.cardNumber}}</h3>
        </div>
      </div>
      <div class="card-info-cell">
        <div>
          <p>Datum isteka kartice</p>
          <h3>{{$props.cardDate}}</h3>
        </div>
      </div>
    </div>
    <div class="card-delete">
      <base-button variant="text"
                   class="card-delete-button"
                   @click="emitDeleteEvent">
        <i class="icon-sc-delete"></i>
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'single-payment-card',
  props: {
    cardName: String,
    cardNumber: String,
    cardDate: String,
    cardCode: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    emitDeleteEvent () {
      this.$emit('delete-card', this.$props.cardCode)
    }
  }
}
</script>

<style scoped lang="scss">
.card-single {
  border-radius: 0.5rem;
  background-color: $white;
  margin-bottom: 0.8rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  min-height: 83px;
  overflow: hidden;

  @media (map_get($breakpoints, sm)) {
    flex-direction: row;
  }

  @media (map_get($breakpoints, lg)) {
    height: 83px; // IE fix
  }

  .card-information {
    padding: 1.6rem 2.4rem;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background-color: transparent;

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
    }

    .card-info-cell {
      color: $text;
      text-align: left;
      position: relative;
      flex: 1 1 25%;
      display: flex;
      padding: 1.2rem 0;

      @media (map_get($breakpoints, sm)) {
        justify-content: center;
        padding: 0;
      }

      &:first-child {
        flex-basis: 12.5%;
        justify-content: flex-start;
        padding-bottom: 1.2rem;
        padding-top: 0;

        @media (map_get($breakpoints, sm)) {
          padding-bottom: 0;
        }
      }

      &:not(:first-child)::before {
        position: absolute;
        content: '';
        left: 0;
        width: 100%;
        top: 0;
        height: 1px;
        background: $grey;

        @media (map_get($breakpoints, sm)) {
          top: 2px;
          bottom: 2px;
          width: 1px;
          height: auto;
        }
      }

      &:last-child {
        padding-top: 1.2rem;
        padding-bottom: 0;

        @media (map_get($breakpoints, sm)) {
          padding-top: 0;
        }

        @media (map_get($breakpoints, lg)) {
          margin-right: 12rem;
        }
      }

      p {
        font-size: 1.2rem;
        margin-bottom: 0.8rem;
      }

      h3 {
        font-size: 1.6rem;
        font-weight: bold;
        margin: 0;
      }
    }

    .v-divider {
      height: 100%;
      position: relative;

      &::before {
        position: absolute;
        content: '';
        left: 50%;
        top: 2px;
        bottom: 2px;
        width: 1px;
        background: $grey;
      }
    }
  }

  .card-delete {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    box-shadow: 0 -3px 8px 0 rgba(0, 0, 0, 0.06);

    @media (map_get($breakpoints, sm)) {
      box-shadow: -3px 0 8px 0 rgba(0, 0, 0, 0.06);
    }

    .card-delete-button {
      padding: 1.6rem !important;
      width: 100%;
      font-size: 1.8rem;

      @media (map_get($breakpoints, sm)) {
        padding: 3rem 1.6rem !important;
      }
    }
  }
}
</style>
